var Config={
  loginLogo:"/images/babusiya.svg",
  babusiyaLogo:"/images/babusiya_logo.svg",
  defaultAvatar:"https://static.vecteezy.com/system/resources/thumbnails/009/292/244/small/default-avatar-icon-of-social-media-user-vector.jpg"
}
export default Config